import { Button, ColumnDefinition, ComboBox, DatePicker, Icon, Modal, Table, TextInput } from '@abb/common-ux';
import { INVALID_SERVICE_VALUE, isValidInput, PO_NUMBER_MAX_LENGTH } from '@service/constants';
import * as moment from 'moment';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Option } from 'react-select';
import { IConnectedComponent } from '../../../../../reducers';
import { Allocation, IAllocationViewModel, IField, ILicensableService, ILicenseAllowance, IServer, ISite } from '../../../models';

// TODO: Look for oppourtunities to reuse code and move functions to container component
/* tslint:disable:no-empty jsx-no-lambda jsx-self-close jsx-no-multiline-js*/
export class LicenseAllowanceTable extends React.Component<ILicenseAllowanceTableProps & IConnectedComponent, any> {

  constructor(props: ILicenseAllowanceTableProps & IConnectedComponent) {
    super(props);
    this.state = {
      serviceBeingEdited: new Allocation(this.props.match.params.siteId),
      productNameBeingEdited: null,
      mappedAllocations: [],
      isModalOpen: false,
      licenseAllowanceToDelete: null
    };
    this.handleProductNameChange = this.handleProductNameChange.bind(this);
    this.handleExpirationDateInputChange = this.handleExpirationDateInputChange.bind(this);
    this.renderExpirationDateTextInput = this.renderExpirationDateTextInput.bind(this);
  }

  render() {
    const LicenseAllowanceTableColumn = ColumnDefinition as new () => ColumnDefinition<IAllocationViewModel>;
    const deleteButton = (
      <span>
        <Button buttonType='normal' buttonSize='default' onClick={() => {
          this.setState({
            isModalOpen: false,
            licenseAllowanceToDelete: null
          });
        }} >
          <span aria-hidden='true'>Cancel</span>
        </Button>
        <Button buttonType='primary' buttonSize='default' onClick={() => {
          this.props.DeleteAllocation(this.state.licenseAllowanceToDelete, this.state.licenseAllowanceToDelete.siteId);
          this.setState({
            isModalOpen: false,
            licenseAllowanceToDelete: null,
          });
        }} >
          <span aria-hidden='true'>Confirm</span>
        </Button>
      </span>);

    let allowanceTable;
    if (this.props.userPermissions && this.props.userPermissions.isAdmin) {
      allowanceTable = (
        <Table data={this.state.mappedAllocations} emptyMessage={'This site has no license allowances.'}>
          <LicenseAllowanceTableColumn columnWidth={3} nowrap={true} cell={(row) => this.renderServiceTypeComboBoxCol(row.allocation)} header='Service' />
          <LicenseAllowanceTableColumn columnWidth={2} nowrap={true} cell={(row) => this.renderAssetType(row.allocation)} header='Asset Type' />
          <LicenseAllowanceTableColumn columnWidth={1} nowrap={true} cell={(row) => this.renderExpirationDateTextInput(row.allocation)} header='Expiration' />
          <LicenseAllowanceTableColumn columnWidth={1} nowrap={true} cell={(row) => this.renderTextCell(row.allocation, 'totalAssetAllocation', this.handleTotalAssetAllocationChange, this.handleAssetCountErrorMessage())} header='Asset Count' />
          <LicenseAllowanceTableColumn columnWidth={1} nowrap={true} cell={(row) => row.allocatedAssets.toString()} header='Allocated' />
          <LicenseAllowanceTableColumn columnWidth={1} nowrap={true} cell={(row) => row.availableAssets.toString()} header='Available' />
          <LicenseAllowanceTableColumn columnWidth={2} nowrap={true} cell={(row) => this.renderTextCell(row.allocation, 'productOrderNumber', this.handleProductOrderNumberChange, 'Alphanumeric field cannot exceed 10 characters')} header='PO#' />
          <LicenseAllowanceTableColumn columnWidth={1} nowrap={true} cell={(row) => this.renderManageIcons(row.allocation)} header='Manage' />
        </Table>);
    } else {
      allowanceTable = (
        <Table data={this.state.mappedAllocations} emptyMessage={'This site has no license allowances.'}>
          <LicenseAllowanceTableColumn columnWidth={2} nowrap={true} cell={(row) => this.renderTextCell(row.allocation, 'productOrderNumber', this.handleProductOrderNumberChange, 'Alphanumeric field cannot exceed 10 characters')} header='PO#' />
          <LicenseAllowanceTableColumn columnWidth={3} nowrap={true} cell={(row) => this.renderServiceTypeComboBoxCol(row.allocation)} header='Service' />
          <LicenseAllowanceTableColumn columnWidth={2} nowrap={true} cell={(row) => this.renderAssetType(row.allocation)} header='Asset Type' />
          <LicenseAllowanceTableColumn columnWidth={1} nowrap={true} cell={(row) => this.renderExpirationDateTextInput(row.allocation)} header='Expiration' />
          <LicenseAllowanceTableColumn columnWidth={1} nowrap={true} cell={(row) => this.renderTextCell(row.allocation, 'totalAssetAllocation', this.handleTotalAssetAllocationChange, this.handleAssetCountErrorMessage())} header='Asset Count' />
          <LicenseAllowanceTableColumn columnWidth={1} nowrap={true} cell={(row) => row.allocatedAssets.toString()} header='Allocated' />
          <LicenseAllowanceTableColumn columnWidth={1} nowrap={true} cell={(row) => row.availableAssets.toString()} header='Available' />
        </Table>);
    }

    return (
      <div>
        {allowanceTable}
        <Modal isOpen={this.state.isModalOpen}
          header='Confirmation'
          footer={deleteButton}
          onClose={() => { this.closeModal(); }}
          modalClassName='styleGuideModal'>
          Deleting a service removes all corresponding instances. Please confirm.
          </Modal>
      </div>
    );
  }

  renderAssetType(allocation: ILicenseAllowance) {
    return allocation.id === this.state.serviceBeingEdited.id ? this.state.serviceBeingEdited.licensableService.assetType.assetTypeName : allocation.licensableService.assetType.assetTypeName;
  }
  renderTextCell(allocation: ILicenseAllowance, field: string, onChangeFunction: any, errorMessage: string) {
    if (allocation.isBeingEdited) {
      return <TextInput name='LicenseAllowanceInput'
        labelText=''
        inputSize='small'
        validationState={this.state.serviceBeingEdited[field].valid ? 'valid' : 'invalid'}
        defaultValue={this.state.serviceBeingEdited[field].value}
        errorMessage={errorMessage}
        onChange={onChangeFunction.bind(this, allocation)} />;
    }
    return allocation[field].value.toString();
  }
  renderExpirationDateTextInput(allocation: ILicenseAllowance) {
    if (allocation.isBeingEdited) {
      // this check allows us to bind the value of the field to serviceBeingEdited while still populating
      // the current expiration date initially, before serviceBeingEdited has been set to a new date
      if (this.state.serviceBeingEdited.expirationDateUtc === new Allocation().expirationDateUtc) {
        this.setState({ serviceBeingEdited: allocation });
      }
      return <DatePicker id='normal'
        date={moment(this.state.serviceBeingEdited.expirationDateUtc.value)}
        onDateChange={this.handleExpirationDateInputChange}
        errorMessage='Must be a valid date'
        isOutsideRange={(day: any) => moment().isSameOrAfter(day)}
        validationState={this.state.serviceBeingEdited.expirationDateUtc.valid ? 'valid' : 'invalid'} />;
    }
    return moment(allocation.expirationDateUtc.value).format('MM/DD/YYYY');
  }

  handleExpirationDateInputChange(date: any) {
    this.setState({
      serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
        expirationDateUtc: { value: date, valid: date._isValid }
      })
    });
  }

  handleTotalAssetAllocationChange(allocation: ILicenseAllowance, e: any) {
    const indexBeingEdited = this.state.mappedAllocations.map((a: any) => a.allocation.isBeingEdited).indexOf(true);
    this.setState({
      serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
        totalAssetAllocation: {
          value: e.currentTarget.value,
          valid: !isNaN(e.currentTarget.value) && parseInt(e.currentTarget.value, 10) >= this.state.mappedAllocations[indexBeingEdited].allocatedAssets && parseInt(e.currentTarget.value, 10) > 0
        }
      })
    });
  }

  handleAssetCountErrorMessage() {
    return (this.props.allocationIsAddingNew) ? 'Number must be greater than zero' : 'Number must be greater than or equal to the allocated amount';
  }

  handleProductOrderNumberChange(allocation: ILicenseAllowance, e: any) {
    this.setState({
      serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
        productOrderNumber: {
          value: e.currentTarget.value,
          valid: isValidInput(e.currentTarget.value, PO_NUMBER_MAX_LENGTH)
        }
      })
    });
  }

  renderServiceTypeComboBoxCol = (allocation: ILicenseAllowance) => {
    if (allocation.isBeingEdited && allocation.licensableService.productName === '') {
      let options: Array<{ label: any; value: any; assetType: any; licenseParameters?: any; licensePassword?: any; }> = [];
      this.props.serviceOptions.licensableServices.forEach((service: any) => {
        const optionToAdd = {
          label: service.productName,
          value: service.id,
          assetType: service.assetType.assetTypeName,
          licenseParameters: service.assetType.licenseParameters,
          licensePassword: service.assetType.licensePassword
        };
        options.push(optionToAdd);
      });
      if (this.state.serviceBeingEdited.licensableService.productName !== allocation.licensableService.productName && this.state.serviceBeingEdited.licensableService.productName && !options.some((option: any) => option.label === allocation.licensableService.productName)) {
        options.push({
          label: allocation.licensableService.productName,
          value: allocation.licensableService.id,
          assetType: allocation.licensableService.assetType.assetTypeName,
          licenseParameters: allocation.licensableService.licenseParameters,
          licensePassword: allocation.licensableService.licensePassword
        });
      }
      options = options.filter((licensableService: any) => licensableService.value !== this.state.serviceBeingEdited.licensableService.id && licensableService.value !== INVALID_SERVICE_VALUE);
      return <ComboBox value={this.state.productNameBeingEdited} onChange={this.handleProductNameChange} size='small' options={options} />;
    }
    return allocation.licensableService.productName;
  }

  renderManageIcons = (allocation: ILicenseAllowance) => {
    if (allocation.isBeingEdited) {
      return <div>
        <Button buttonType='normal' buttonSize='minimal' icon='save' disabled={!this.state.serviceBeingEdited.expirationDateUtc.valid || !this.state.serviceBeingEdited.productOrderNumber.valid || !this.state.serviceBeingEdited.totalAssetAllocation.valid} onClick={() => this.handleUpdateAllocation(this.state.serviceBeingEdited)} />
        <Button buttonType='normal' buttonSize='minimal' icon='close' onClick={() => this.handleCancelAllocationEdit(allocation)} />      </div>;
    }
    return <div>
      <Button buttonType='normal' buttonSize='minimal' icon='edit' disabled={this.props.allocationIsAddingNew} onClick={() => this.handleEditExistingRow(allocation, this.props.match.params.siteId)} />
      <Button buttonType='normal' buttonSize='minimal' icon='trash' disabled={this.props.allocationIsAddingNew} onClick={() => {
        this.setState({
          isModalOpen: true,
          licenseAllowanceToDelete: allocation
        });
      }} />
    </div>;
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
      licenseAllowanceToDelete: null
    });
  }

  handleProductNameChange(productType: Option) {
    const serviceList = this.props.serviceOptions.licensableServices.filter((licensableService: any) => licensableService.id === productType.value);
    this.setState({
      serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
        licensableService: serviceList.length > 0 ? serviceList[0] : {
          assetType: { assetTypeName: productType.assetType, id: productType.id },
          id: productType.id,
          licenseParameters: productType.licenseParameters,
          licensePassword: productType.licensePassword,
          productName: productType.label
        }
      }),
      productNameBeingEdited: {
        label: productType.label,
        value: productType.value
      }
    });
  }

  handleUpdateAllocation(serviceBeingEdited: any) {
    if (serviceBeingEdited.id === -1) {
      this.props.addAllocation(serviceBeingEdited);
    } else { this.props.UpdateAllocation(serviceBeingEdited); }
    this.setState({ serviceBeingEdited: new Allocation(this.props.match.params.siteId), productNameBeingEdited: '' });
  }

  handleCancelAllocationEdit(serviceBeingEdited: any) {
    this.props.CancelAllocationEdit(serviceBeingEdited);
    this.setState({ serviceBeingEdited: new Allocation(this.props.match.params.siteId), productNameBeingEdited: '' });
  }

  handleEditExistingRow(allocation: any, siteId: number) {
    this.setState({ serviceBeingEdited: allocation });
    this.setState({ productNameBeingEdited: { label: allocation.licensableService.productName, value: allocation.licensableService.assetType.id } });
    this.props.EditExistingRow(allocation, siteId);
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({
      mappedAllocations: nextProps.licenseAllowances.map((licenseAllowances: ILicenseAllowance) => {
        const allocatedAssets = nextProps.server.map((server: IServer) => {
          return server.serviceAllocations.map((serviceAllocation: any) => {
            if (serviceAllocation.selectedServiceType.productName === licenseAllowances.licensableService.productName) {
              return serviceAllocation.allocatedAssets.value;
            }
            return 0;
          }).reduce((a: number, b: number) => {
            return Number(a) + Number(b);
          }, 0);
        }).reduce((first: number, second: number) => Number(first) + Number(second), 0);
        return {
          allocation: licenseAllowances,
          allocatedAssets,
          availableAssets: licenseAllowances.totalAssetAllocation.value - allocatedAssets,
        };
      })
    });
  }
}

export default withRouter(connect(mapStateToProps)(LicenseAllowanceTable) as any);

export function mapStateToProps(store: any) {
  return { ...store.servicesState, ...store.serviceOptionsState, ...store.serverState, userPermissions: store.userState.userPermissions };
}

export interface ILicenseAllowanceTableProps {
  licenseAllowances: ILicenseAllowance[];
  serviceOptions: any;
  requestServices: any;
  addAllocation: any;
  AddNewEditableRow: any;
  EditExistingRow: any;
  CancelAllocationEdit: any;
  UpdateAllocation: any;
  DeleteAllocation: any;
  allocationIsAddingNew: boolean;
  match: any;
  server: any;
  permissions: string[];
  errorMessage: string;
  licenseAllowanceErrorMessageVisible: boolean;
  clearErrorMessage: any;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/SiteLicense/LicenseAllowance/LicenseAllowanceTable.tsx